export default {
      id: "circleRemove-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#circleRemove-usage",
      toString: function () {
        return this.url;
      }
    }